import React, { MouseEvent } from "react";
import { AxiosResponse, AxiosError } from "axios";
import DataGrid, { Pager, Paging, FilterRow, Column, Export, SearchPanel, Selection } from "devextreme-react/data-grid";
import { LoadIndicator, Popup, ScrollView } from "devextreme-react";
import gridUtils from "../grid/GridUtilities";
import PaymentService, { PaymentGridRowItem } from "../../services/PaymentService";
import paymentActionCell from "../Payments/PaymentActionCellComponent";
import UserService, { RoleGroupNames } from "../../services/UserService";
import { DataGridOnSelectionChanged, onExportingEvent } from "../../types/DevExtremeTypes";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import InvoiceAmountCell from "../Payments/ProviderPayment/InvoiceAmountCellComponent";
import sharedUtils from "../grid/sharedUtilities";
import GlobalService from "../../services/GlobalService";
import { Link } from "react-router-dom";
import SimpleShiftsByService from "../SimpleShiftsByService/SimpleShiftsByService";
import { closeDrawer } from "../header/NavigationUtils";
import { saveAs } from "file-saver";
import { PaymentFormData } from "../Payments/PaymentFormUtils";
import { Button, LoadPanel } from "devextreme-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/pro-regular-svg-icons";
import ManageDocumentsGridService, { logicAppRegeneratePostRequest } from "../../services/ManageDocumentsGridService";
interface NewPaymentsGridProps {
    setCalculations: (CalculationsObject: any) => void;
    setPaymentCycleIdOnParent: (paymentCycleId: string) => void;
    id: string;
    paymentsRefresh: boolean;
    pontOfNavigation: string;
    pageType?: string;
    previewUpdate?: (isPreview: boolean, isError: boolean, error: []) => void;
    paymentData?: PaymentFormData;
    setPaymentCycleIds?: (idObj: any[]) => void;
    unSelectRowsChange?: () => void;
    unSelectRows?: boolean;
}
interface AggregatedRecord {
    providerId: string;
    providerName: string;
    service: string;
    payDate: string;
    providerNet: string;
    providerVAT: string;
    providerTotal: string;
    accountNumber: string;
    sortCode: string;
    shiftCompleteAcknowledgmentDateTime: string;
    businessEntityVATApplicable: string;
    businessEntityVATVerified: string;
    businessEntityVerified: string;
    objects: PaymentGridRowItem[];
}
interface NewPaymentsGridState {
    gridDataSource: PaymentGridRowItem[];
    gridDataSourceForPreview: any[];
    showProgressIndicator: boolean;
    CalculationsObject: {
        subTotal: string;
        total: string;
        tax: string;
    };
    checkSquareIconVisible: boolean;
    simpleShiftPopupVisible: boolean;
    simpleShiftPopupVisibleData: any[];
    serviceId: string;
    paymentId: string;
    errorMessage: [];
    loadPanelVisible: false;
}

class NewPaymentsGrid extends React.Component<NewPaymentsGridProps> {
    state: NewPaymentsGridState;
    //Initialize the service to fetch the data.
    Service: PaymentService;
    //Reuse the Grid utils component to format the cells.
    gridUtils: gridUtils;
    sharedUtils: sharedUtils;
    userHasAccess: boolean;
    dataGridRef: any;
    service: ManageDocumentsGridService;
    constructor(props: NewPaymentsGridProps) {
        super(props);
        // Initialize state and services/utils
        this.Service = new PaymentService();
        this.gridUtils = new gridUtils();
        this.sharedUtils = new sharedUtils();
        this.service = new ManageDocumentsGridService();
        this.userHasAccess =
            UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager) ||
            UserService.isUserInGroup(RoleGroupNames.EventUKRelationshipManager);
        this.state = {
            gridDataSource: [],
            gridDataSourceForPreview: [],
            showProgressIndicator: false,
            CalculationsObject: {
                subTotal: "",
                total: "",
                tax: "",
            },
            checkSquareIconVisible: false,
            simpleShiftPopupVisible: false,
            simpleShiftPopupVisibleData: [],
            serviceId: "",
            paymentId: "",
            errorMessage: [],
            loadPanelVisible: false,
        };
        this.Calculations = this.Calculations.bind(this);
        this.updateGridDataSource = this.updateGridDataSource.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleError = this.handleError.bind(this);
        this.dataGridRef = null;
    }

    componentDidMount() {
        this.updateGridDataSource();
    }

    componentDidUpdate(prevprops: NewPaymentsGridProps) {
        if (this.props.paymentsRefresh != prevprops.paymentsRefresh) {
            this.updateGridDataSource();
        }
        if (this.props.unSelectRows != prevprops.unSelectRows && this.props.unSelectRows) {
            this.dataGridRef?.instance().clearSelection();
            if (this.props.unSelectRowsChange) {
                this.props.unSelectRowsChange();
            }
        }
    }

    onExporting = (e: onExportingEvent) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            //topLeftCell: { row: 2, column: 2 },
            customizeCell: ({ gridCell, excelCell }) => {
                if (gridCell && gridCell.rowType === "data") {
                    if (
                        gridCell.column &&
                        (gridCell.column.dataField === "subAmount" ||
                            gridCell.column.dataField === "tax" ||
                            gridCell.column.dataField === "amount" ||
                            gridCell.column.dataField === "lastPayment" ||
                            gridCell.column.dataField === "varience")
                    ) {
                        excelCell.value = parseFloat(gridCell.value);
                        excelCell.numFmt = "£#,##0.00";
                    }
                }
            },
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx");
            });
        });
        e.cancel = true;
    };

    // Fire parent component's callback with data from grid
    onSelectionChanged = (event: DataGridOnSelectionChanged) => {
        // Capture the PaymentId of the clicked row.
        if (window.location.href.indexOf("PaymentsV2Page")) {
            if (event.selectedRowKeys) {
                this.props.setPaymentCycleIds ? this.props.setPaymentCycleIds(event.selectedRowKeys) : null;
                event.selectedRowKeys.forEach((items) => {
                    GlobalService.setPaymentCycleIds(items.paymentId);
                });
            }
        } else {
            var paymentId: string = "";
            if (event.selectedRowsData && event.selectedRowsData.length > 0) {
                paymentId = event.selectedRowsData[0].paymentId;
            }
            this.props.setPaymentCycleIdOnParent(paymentId);
        }
    };

    handleCalculations = () => {
        let subTotal = 0.0,
            tax = 0.0,
            amount = 0.0;
        let subtotalValues = this.state.gridDataSource.map((item) => item.subAmount);
        let taxValues = this.state.gridDataSource.map((item) => item.tax);
        let amountValues = this.state.gridDataSource.map((item) => item.amount);
        subtotalValues.forEach((rowElement) => {
            subTotal = subTotal + this.gridUtils.convertDecimalAsStringToFloat(rowElement);
        });

        taxValues.forEach((rowElement) => {
            tax = tax + this.gridUtils.convertDecimalAsStringToFloat(rowElement);
        });

        amountValues.forEach((rowElement) => {
            amount = amount + this.gridUtils.convertDecimalAsStringToFloat(rowElement);
        });
        amount =  Number(amount.toFixed(2)),
        subTotal= Number(subTotal.toFixed(2)),
        tax= Number(tax.toFixed(2)),
        this.setState(
            {
                CalculationsObject: {
                    ...this.state.CalculationsObject,
                    total: amount.toString(),
                    subTotal: subTotal.toString(),
                    tax: tax.toString(),
                },
            },
            () => this.Calculations()
        );
    };

    Calculations() {
        this.props.setCalculations(this.state.CalculationsObject);
    }
    setUpPaymentsPreviewGrid() {
        if (this.props.paymentData) {
            let obj: any = { ...this.props.paymentData };
            obj.subTotal = "";
            obj.tax = "";
            (obj.total = ""), (obj.paidDate = "");
            obj.payDate = this.sharedUtils.convertDateToString(obj.payDate);
            this.Service.getPaymentPreviewRowItems(obj)
                .then(this.handleSuccess)
                .catch((err) => {
                    this.setState(
                        {
                            errorMessage: err?.response?.data?.error
                                ? JSON.parse(JSON.stringify(err.response.data.error))
                                : null,
                        },
                        () => {
                            this.handleError(err);
                        }
                    );
                })
                .finally(() => {
                    this.setState({
                        showProgressIndicator: false,
                    });
                });
        }
    }

    updateGridDataSource() {
        if (this.userHasAccess) {
            this.setState({
                showProgressIndicator: true,
            });
            if (this.props.pontOfNavigation && this.props.pontOfNavigation == "failedPayments") {
                this.Service.getPaymentGridRowFailedItems(this.props.id)
                    .then(this.handleSuccess)
                    .catch(this.handleError);
            } else if (this.props.pageType && this.props.pageType == "PaymentsPreview") {
                // call for preview API
                this.setUpPaymentsPreviewGrid();
            } else {
                this.Service.getPaymentGridRowItems(this.props.id).then(this.handleSuccess).catch(this.handleError);
            }
        }
    }

    aggregatePayments(data: any[]) {
        const groupedMap = new Map<string, AggregatedRecord>();

        data.forEach((record) => {
            const key = `${record.providerId}_${record.service}_${record.payDate}`;

            if (!groupedMap.has(key)) {
                groupedMap.set(key, {
                    providerId: record.providerId,
                    providerName: record.provider,
                    service: record.service,
                    payDate: record.payDate,
                    providerNet: "0.00",
                    providerVAT: "0.00",
                    providerTotal: "0.00",
                    accountNumber: record.accountNumber,
                    sortCode: record.sortCode,
                    shiftCompleteAcknowledgmentDateTime: record.shiftCompleteAcknowledgmentDateTime,
                    businessEntityVATApplicable: record.businessEntityVATApplicable ? "True" : "False",
                    businessEntityVATVerified: record.businessEntityVATVerified ? "True" : "False",
                    businessEntityVerified: record.businessEntityVerified ? "True" : "False",
                    objects: [],
                });
            }

            const group = groupedMap.get(key)!;

            const providerPayAmountLocal = parseFloat(record.providerPayAmountLocal || "0");
            const providerPayAmountTaxLocal = parseFloat(record.providerPayAmountTaxLocal || "0");
            const providerPayAmountTotalLocal = parseFloat(record.providerPayAmountTotalLocal || "0");

            group.providerNet = (parseFloat(group.providerNet) + providerPayAmountLocal).toFixed(2);
            group.providerVAT = (parseFloat(group.providerVAT) + providerPayAmountTaxLocal).toFixed(2);
            group.providerTotal = (parseFloat(group.providerTotal) + providerPayAmountTotalLocal).toFixed(2);

            group.objects.push(record);
        });
        const aggregatedRecords = Array.from(groupedMap.values());
        this.setState(
            {
                gridDataSourceForPreview: aggregatedRecords,
                showProgressIndicator: false,
                errorMessage: [],
            },
            () => {
                this.props.previewUpdate ? this.props.previewUpdate(false, false, []) : null;
            }
        );
        let totalProviderNet = 0;
        let totalProviderVAT = 0;
        let totalProviderGross = 0;
        aggregatedRecords.map(
            (item) => (
                (totalProviderGross += parseFloat(item.providerTotal)),
                (totalProviderNet += parseFloat(item.providerNet)),
                (totalProviderVAT += parseFloat(item.providerVAT))
            )
        );
        this.props.setCalculations({
            total: totalProviderGross.toString(),
            subTotal: totalProviderNet.toString(),
            tax: totalProviderVAT.toString(),
        });
    }
    handleSuccess(response: AxiosResponse<any>) {
        if (this.props.pageType == "PaymentsPreview") {
            this.aggregatePayments(response.data.data);
        } else {
            this.setState(
                {
                    gridDataSource: response.data.data,
                    showProgressIndicator: false,
                    errorMessage: [],
                },
                () => {
                    this.props.previewUpdate ? this.props.previewUpdate(false, false, []) : null;
                    this.handleCalculations();
                }
            );
        }
    }

    handleError(error: AxiosError<any>) {
        this.setState({
            showProgressIndicator: false,
        });
        var respMessage: string = "Get payment Grid rows service load failed with response: " + JSON.stringify(error);

        if (!this.Service.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
        this.props.previewUpdate ? this.props.previewUpdate(false, true, this.state.errorMessage) : null;
    }

    setVarianceColour = (cellElement: any, cellInfo: any) => {
        var cellVarianceWithCurrencySymbol = this.sharedUtils.thousandsSeparator(cellInfo.data.varience);
        if (cellInfo.data.rag == "Green" && cellInfo.data.varience) {
            cellElement.classList.add("text-success");
        } else if (cellInfo.data.rag == "Amber" && cellInfo.data.varience) {
            cellElement.classList.add("text-warning");
        }
        if (cellInfo.data.varience) {
            cellElement.append(cellVarianceWithCurrencySymbol);
        }
    };

    headerExcludeCellTemplate = () => {
        return <div>EXCLUDE</div>;
    };

    headerBouncedCellTemplate = () => {
        return (
            <div>
                {" "}
                <span>BOUNCED?</span>{" "}
            </div>
        );
    };

    DisplaySimpleShiftGrid = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showSimpleShiftGrid(cellInfo.data);
                    }}
                    className="approval-query-column top-12px"
                    to="#"
                >
                    {this.sharedUtils.thousandsSeparator(cellInfo.data.subAmount)}
                </Link>
            </div>
        );
    };
    DisplaySimpleShiftGridPreview = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showSimpleShiftGridPreview(cellInfo.data);
                    }}
                    className="approval-query-column top-12px"
                    to="#"
                >
                    {this.sharedUtils.thousandsSeparator(cellInfo.data.providerNet)}
                </Link>
            </div>
        );
    };
    showSimpleShiftGridPreview = (cellInfo: any) => {
        this.setState(
            {
                simpleShiftPopupVisible: true,
                simpleShiftPopupVisibleData: cellInfo.objects,
                // serviceId: cellInfo.serviceId,
                // paymentId: cellInfo.paymentId,
            },
            () => {
                closeDrawer();
            }
        );
    };
    showSimpleShiftGrid = (cellInfo: any) => {
        this.setState(
            {
                simpleShiftPopupVisible: true,
                serviceId: cellInfo.serviceId,
                paymentId: cellInfo.paymentId,
            },
            () => {
                closeDrawer();
            }
        );
    };
    hideSimpleShiftGrid = () => {
        this.setState({
            simpleShiftPopupVisible: false,
        });
    };
    setCalculations = () => {};

    onRefresh = (isRefresh: boolean) => {
        if (isRefresh) {
            this.updateGridDataSource();
        }
    };

    InvoiceAmountCell = (cellInfo: any) => {
        return (
            <>
                <InvoiceAmountCell data={cellInfo} onRefresh={this.onRefresh} />
            </>
        );
    };
    renderInvoiceDownloadButton = (cellInfo: any) => {
        let showDownload = false;
        if (cellInfo && cellInfo.data.documents) {
            let filtered = cellInfo.data.documents.filter(
                (item: any) => item.documentType.toLowerCase() == "remittance"
            );
            if (filtered && filtered.length > 0) {
                showDownload = true;
            }
        }
        if (showDownload) {
            return (
                <>
                    <Button
                        className="btn icon-btn btn-file-downloader"
                        onClick={(e) => this.onDownloadClick(e, cellInfo)}
                    >
                        <FontAwesomeIcon icon={faDownload} />
                    </Button>
                </>
            );
        }
    };
    onDownloadClick = (event: any, cellInfo: any) => {
        var id = "";
        if (cellInfo && cellInfo.data.documents) {
            cellInfo.data.documents.map((item: any) => {
                if (item.documentType.toLowerCase() == "remittance") {
                    id = item.id;
                }
            });
        }
        this.setState({
            loadPanelVisible: true,
        });

        this.service
            .getDocumentById(id)
            .then((res) => this.handleDownloadSuccess(res, cellInfo))
            .catch(this.handleDownloadError);
        event.event.stopPropagation();
    };
    handleDownloadSuccess = (response: AxiosResponse<any>, cellInfo: any) => {
        var linkRaw = "";
        if (cellInfo && cellInfo.data.documents) {
            cellInfo.data.documents.map((item: any) => {
                if (item.documentType.toLowerCase() == "remittance") {
                    linkRaw = item.link;
                }
            });
        }
        let link = linkRaw.split("/");
        let filename = link[link.length - 1];
        var FileSaver = require("file-saver");
        FileSaver.saveAs(response.data, filename);
        this.setState({
            loadPanelVisible: false,
        });
    };

    handleDownloadError = (error: any) => {
        this.setState({
            loadPanelVisible: false,
        });
        var respMessage: string = "getDocumentById failed with response: " + JSON.stringify(error);

        if (!this.service.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
    };
    renderRemittanceCell = (cellInfo: any) => {
        return (
            <div className="d-flex justify-content-between align-items-center">
                <div style={{ minWidth: "70px", marginRight: "10%", width: "70%" }}>{cellInfo.data.remittanceDate}</div>
                <div style={{ minWidth: "50px", width: "20%" }}>{this.renderInvoiceDownloadButton(cellInfo)}</div>
            </div>
        );
    };

    render() {
        return (
            <div>
                <h4 className="ml-3 font-weight-bold"></h4>
                {this.state.loadPanelVisible ? (
                    <LoadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        visible={this.state.loadPanelVisible}
                        style={{
                            position: "absolute",
                        }}
                    />
                ) : null}
                {this.state.showProgressIndicator ? (
                    <div className="starter-template">
                        <LoadIndicator
                            id="simple-grid-indicator"
                            height={50}
                            width={50}
                            visible={this.state.showProgressIndicator}
                        />
                    </div>
                ) : this.props.pageType === "PaymentsPreview" ? (
                    <DataGrid
                        dataSource={this.state.gridDataSourceForPreview}
                        showBorders={false}
                        showColumnLines={false}
                        hoverStateEnabled={true}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                        columnResizingMode={"widget"}
                        onSelectionChanged={this.onSelectionChanged}
                        onExporting={this.onExporting}
                        ref={(ref) => {
                            this.dataGridRef = ref;
                        }}
                    >
                        <Paging defaultPageSize={10} />
                        {/* <Selection mode="multiple" selectAllMode="allPages" showCheckBoxesMode="always"></Selection>                       */}
                        <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />
                        <Export enabled={true} />
                        <SearchPanel visible={true} placeholder={"Search"} />
                        <Column
                            dataField="providerId"
                            cellRender={(data) => (
                                <div style={{ height: "35px", display: "flex", alignItems: "center" }}>
                                    {data.value}
                                </div>
                            )}
                        />
                        <Column dataField="providerName" caption="PROVIDER NAME" />
                        <Column dataField="service" caption="PROVIDER SERVICE" />
                        <Column
                            dataField="providerNet"
                            caption="PROVIDER NET"
                            cellRender={this.DisplaySimpleShiftGridPreview}

                            // calculateSortValue={(rowData: any) => {
                            //     return this.gridUtils.convertDecimalAsStringToFloat(rowData.providerTotal);
                            // }}
                        />
                        <Column
                            dataField="providerVAT"
                            caption="PROVIDER VAT"
                            calculateDisplayValue={(rowData: any) => {
                                return this.sharedUtils.thousandsSeparator(rowData.providerVAT);
                            }}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.providerVAT);
                            }}
                        />
                        <Column
                            dataField="providerTotal"
                            caption="PROVIDER GROSS"
                            calculateDisplayValue={(rowData: any) => {
                                return this.sharedUtils.thousandsSeparator(rowData.providerTotal);
                            }}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.providerTotal);
                            }}
                        />
                        <Column
                            dataField="payDate"
                            caption="EARLIEST PAY DATE"
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.payDate);
                            }}
                            calculateCellValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.payDate);
                            }}
                            format="dd/MM/yyyy"
                            dataType="date"
                        />
                        <Column dataField="sortCode" caption="SORT CODE" />
                        <Column dataField="accountNumber" caption="BANK ACCOUNT" />
                        <Column
                            dataField="businessEntityVATApplicable"
                            caption="VAT"
                            allowGrouping={false}
                            allowFiltering={false}
                            allowSearch={false}
                            allowSorting={false}
                        />
                        <Column
                            dataField="businessEntityVATVerified"
                            caption="VAT VERIFIED"
                            allowGrouping={false}
                            allowFiltering={false}
                            allowSearch={false}
                            allowSorting={false}
                        />
                        <Column
                            dataField="businessEntityVerified"
                            caption="SETUP VERIFIED"
                            allowGrouping={false}
                            allowFiltering={false}
                            allowSearch={false}
                            allowSorting={false}
                        />
                        <Column dataField="shiftCompleteAcknowledgmentDateTime" caption="AGREEMENT DATE" />
                        <FilterRow visible={true} applyFilter="auto" />
                    </DataGrid>
                ) : (
                    <DataGrid
                        dataSource={this.state.gridDataSource}
                        showBorders={false}
                        showColumnLines={false}
                        hoverStateEnabled={true}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                        columnResizingMode={"widget"}
                        onSelectionChanged={this.onSelectionChanged}
                        onExporting={this.onExporting}
                        ref={(ref) => {
                            this.dataGridRef = ref;
                        }}
                    >
                        <Selection mode="single" />
                        <Export enabled={true} />
                        <SearchPanel visible={true} placeholder={"Search"} />
                        <Paging defaultPageSize={10} />
                        <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />
                        {this.props.pontOfNavigation.toLowerCase() == "paymentsandchecks" ? (
                            <Column type="selection" headerCellRender={this.headerExcludeCellTemplate} />
                        ) : this.props.pontOfNavigation.toLowerCase() == "paymentspaid" ? (
                            <Column type="selection" headerCellRender={this.headerBouncedCellTemplate} width={100} />
                        ) : null}
                        <Selection mode="multiple"></Selection>
                        <Column dataField="paymentId" caption="ID" />
                        <Column dataField="entity" caption="PROVIDER" />
                        <Column dataField="entityId" caption="PROVIDER ID" />
                        <Column dataField="serviceValue" caption="SERVICE" />
                        <Column dataField="reference" caption="REFERENCE" />
                        <Column
                            dataField="subAmount"
                            caption="PROVIDER NET"
                            cellRender={this.DisplaySimpleShiftGrid}
                            // calculateDisplayValue={(rowData: any) => {
                            //     return this.sharedUtils.thousandsSeparator(rowData.subAmount);
                            // }}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.subAmount);
                            }}
                        />
                        <Column
                            dataField="tax"
                            caption="PROVIDER VAT"
                            calculateDisplayValue={(rowData: any) => {
                                return this.sharedUtils.thousandsSeparator(rowData.tax);
                            }}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.tax);
                            }}
                        />
                        <Column
                            dataField="amount"
                            caption="PROVIDER GROSS"
                            //cellComponent={InvoiceAmountCell}
                            cellRender={this.InvoiceAmountCell}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.amount);
                            }}
                        />
                        <Column dataField="sortCode" caption="SORT CODE" />
                        <Column dataField="accountNumber" caption="ACCOUNT #" />
                        <Column dataField="status" caption="STATUS" />
                        <Column dataField="action" caption="ACTION" cellComponent={paymentActionCell} />
                        <Column
                            dataField="payDate"
                            caption="EARLIEST PAY DATE"
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.payDate);
                            }}
                            calculateCellValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.payDate);
                            }}
                            format="dd/MM/yyyy"
                            dataType="date"
                        />
                        <Column
                            dataField="lastPayment"
                            caption="LAST PAYMENT"
                            calculateDisplayValue={(rowData: any) => {
                                return this.sharedUtils.thousandsSeparator(rowData.lastPayment);
                            }}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.lastPayment);
                            }}
                        />
                        <Column
                            dataField="varience"
                            caption="VARIANCE"
                            cellTemplate={this.setVarianceColour}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.varience);
                            }}
                        />
                        <Column
                            dataField="advisedDate"
                            caption="INVOICE PAY DATE"
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.advisedDate);
                            }}
                            calculateCellValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.advisedDate);
                            }}
                            format="dd/MM/yyyy"
                            dataType="date"
                        />
                        <Column
                            dataField="paymentDate"
                            caption="PAYMENT DATE"
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.paymentDate);
                            }}
                            calculateCellValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.paymentDate);
                            }}
                            format="dd/MM/yyyy"
                            dataType="date"
                        />
                        <Column
                            dataField="remittanceDate"
                            caption="REMITTANCE DATE"
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.remittanceDate);
                            }}
                            calculateCellValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.remittanceDate);
                            }}
                            format="dd/MM/yyyy"
                            dataType="date"
                            cellRender={(cellInfo) => this.renderRemittanceCell(cellInfo)}
                        />
                        <Column dataField="remittance.emailRemittance" caption="REMITTANCE" />
                        <Column dataField="remittance.email" caption="REMITTANCE EMAIL" />
                        <Column
                            dataField="bounceDate"
                            caption="BOUNCE DATE"
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.bounceDate);
                            }}
                            calculateCellValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.bounceDate);
                            }}
                            format="dd/MM/yyyy"
                            dataType="date"
                        />
                        <Column dataField="rag" caption="RAG" visible={false} />
                        <Column dataField="currency" caption="CURRENCY" visible={false} />
                        <FilterRow visible={true} applyFilter="auto" />
                    </DataGrid>
                )}
                <Popup
                    visible={this.state.simpleShiftPopupVisible}
                    onHiding={this.hideSimpleShiftGrid}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title={"Included Shifts"}
                    // width={"90%"}
                    // height={"80%"}
                >
                    <ScrollView width="100%" height="100%">
                        <SimpleShiftsByService
                            clientId=""
                            venueId=""
                            serviceTypeId={this.state.serviceId}
                            startDate=""
                            endDate=""
                            setCalculations={this.setCalculations}
                            paymentId={this.state.paymentId}
                            getBuild={() => {
                                return null;
                            }}
                            simpleShiftPopupVisibleData={
                                this.state.simpleShiftPopupVisibleData ? this.state.simpleShiftPopupVisibleData : []
                            }
                        ></SimpleShiftsByService>
                    </ScrollView>
                </Popup>
            </div>
        );
    }
}
export default NewPaymentsGrid;
